import "../img/apprentices/apprentices-banner.png";
import "../img/apprentices/parent-guardian-overlap.png";
import "../img/icons/apprentice-icon.jpg";
import "../img/videos/get-in-go-far-apprenticeship.png";
import "../img/videos/get-in-go-far-apprenticeship.mp4";

import "../img/traineeships-banner.png";
